<admin-page-second [title]="'pages.channels.configuration.configuration' | translate">
  <admin-section-standard [title]="'pages.channels.configuration.configuration' | translate">
    <admin-channel-view-desc [config]="channel.config"/>

    <admin-panel-empty>
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item" role="presentation">
          <a aria-selected="true" class="nav-link active" data-bs-toggle="tab" href="#input" role="tab">{{'pages.channels.configuration.input' | translate}}</a>
        </li>
        <li class="nav-item" role="presentation">
          <a aria-selected="false" class="nav-link" data-bs-toggle="tab" href="#fields" role="tab" tabindex="-1">{{'pages.channels.configuration.data' | translate}}</a>
        </li>
        <li class="nav-item" role="presentation">
          <a *ngIf="channel?.checks?.checks!.length > 0" aria-selected="false" class="nav-link" data-bs-toggle="tab" href="#checks"
             role="tab" tabindex="-1">{{'pages.channels.configuration.checks' | translate}}</a>
        </li>
        <li class="nav-item" role="presentation">
          <a *ngIf="channel!.rules?.variables!.length > 0" aria-selected="false" class="nav-link" data-bs-toggle="tab" href="#variables"
             role="tab" tabindex="-1">{{'pages.channels.configuration.facts' | translate}}</a>
        </li>
        <li class="nav-item" role="presentation">
          <a *ngIf="channel!.rules?.labels!.length > 0" aria-selected="false" class="nav-link" data-bs-toggle="tab" href="#labels"
             role="tab" tabindex="-1">{{'pages.channels.configuration.labels' | translate}}</a>
        </li>
        <li class="nav-item" role="presentation">
          <a *ngIf="channel!.rules?.references!.length > 0" aria-selected="false" class="nav-link" data-bs-toggle="tab" href="#references"
             role="tab" tabindex="-1">{{'pages.channels.configuration.references' | translate}}</a>
        </li>
        <li class="nav-item" role="presentation">
          <a *ngIf="channel!.rules?.services!.length > 0" aria-selected="false" class="nav-link" data-bs-toggle="tab" href="#services"
             role="tab" tabindex="-1">{{'pages.channels.configuration.services' | translate}}</a>
        </li>
        <li class="nav-item" role="presentation">
          <a *ngIf="channel!.rules?.profiles!.length > 0" aria-selected="false" class="nav-link" data-bs-toggle="tab" href="#profiles"
             role="tab" tabindex="-1">{{'pages.channels.configuration.profiles' | translate}}</a>
        </li>
        <li class="nav-item" role="presentation">
          <a *ngIf="channel!.rules?.rules!.length > 0" aria-selected="false" class="nav-link" data-bs-toggle="tab" href="#rules"
             role="tab" tabindex="-1">{{'pages.channels.configuration.rules' | translate}}</a>
        </li>
      </ul>

      <div class="tab-content bg-white" id="myTabContent">
        <div class="tab-pane fade show active p-3" id="input" role="tabpanel">
          <admin-channels-view-input [input]="channel.input"></admin-channels-view-input>
        </div>
        <div class="tab-pane fade show p-3" id="fields" role="tabpanel">
          <admin-channels-view-fields [fields]="channel.input?.fields"></admin-channels-view-fields>
        </div>
        <div class="tab-pane fade show p-3" id="checks" role="tabpanel">
          <admin-channels-view-checks [settings]="channel.checks"></admin-channels-view-checks>
        </div>
        <div class="tab-pane fade show p-3" id="variables" role="tabpanel">
          <admin-channels-view-variables [variables]="channel.rules?.variables"></admin-channels-view-variables>
        </div>
        <div class="tab-pane fade show p-3" id="labels" role="tabpanel">
          <admin-channels-view-labels [labels]="channel.rules?.labels"></admin-channels-view-labels>
        </div>
        <div class="tab-pane fade show p-3" id="references" role="tabpanel">
          <admin-channels-view-references [rules]="channel.rules?.references"></admin-channels-view-references>
        </div>
        <div class="tab-pane fade show p-3" id="services" role="tabpanel">
          <admin-channels-view-services [rules]="channel.rules?.services"></admin-channels-view-services>
        </div>
        <div class="tab-pane fade show p-3" id="profiles" role="tabpanel">
          <admin-channels-view-profiles [default]="channel.config" [profiles]="channel.rules?.profiles"></admin-channels-view-profiles>
        </div>
        <div class="tab-pane fade show p-3" id="rules" role="tabpanel">
          <admin-channels-view-rules [rules]="channel.rules?.rules"></admin-channels-view-rules>
        </div>
      </div>
    </admin-panel-empty>
  </admin-section-standard>
</admin-page-second>
